// src/components/common/InfoCard/InfoCard.jsx
import React from 'react';
import styles from './InfoCard.module.css';

// Canonical "info card" chrome (icon + title header row, content body), modeled on
// src/pages/orders/OrderDetailsPage.module.css's .card/.cardHeader/.cardTitle/.cardContent.
const InfoCard = ({ icon: Icon, title, actions, children, className = '' }) => (
  <div className={`${styles.card} ${className}`}>
    <div className={styles.cardHeader}>
      <div className={styles.cardTitle}>
        {Icon && <Icon size={20} />}
        <h2>{title}</h2>
      </div>
      {actions}
    </div>
    {children != null && children !== false && (
      <div className={styles.cardContent}>
        {children}
      </div>
    )}
  </div>
);

// Exposed so pages can reuse the .infoGrid/.infoItem label-above-value sub-pattern for their
// own content inside an InfoCard, e.g. <div className={infoCardStyles.infoGrid}>.
export const infoCardStyles = styles;

export default InfoCard;
